import { DrawingToolHelpers } from "../../helpers/drawing-tool-helpers";
import { IComponent } from "../component.interface";
import { IDrawingTool } from "./drawing-tool.interface";
import { DrawingToolsManager } from "./drawing-tools.manager";

export class Elliot3LineComponent implements IComponent, IDrawingTool {
    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    constructor(drawingToolManager: DrawingToolsManager, id: string) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): Elliot3LineComponent {
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;
        
        annotationOptions.typeOptions.points[0].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[0].actualXValue,
            annotationOptions.typeOptions.points[0].actualStartTimeT,
            drawingToolManager);

        annotationOptions.typeOptions.points[1].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[1].actualXValue,
            annotationOptions.typeOptions.points[1].actualStartTimeT,
            drawingToolManager);
            
        annotationOptions.typeOptions.points[2].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[2].actualXValue,
            annotationOptions.typeOptions.points[2].actualStartTimeT,
            drawingToolManager);
            
        annotationOptions.typeOptions.points[3].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[3].actualXValue,
            annotationOptions.typeOptions.points[3].actualStartTimeT,
            drawingToolManager);
            
        const component = new Elliot3LineComponent(drawingToolManager, annotationOptions.id);
        const addedNewAnnotation: any = chart.addAnnotation(annotationOptions);

        drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, false);
        component.annotation = addedNewAnnotation;
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, event: any): Elliot3LineComponent {
        const component = new Elliot3LineComponent(drawingToolManager, event.options.id);
        component.annotation = event;
        return component;
    }

    public syncUpdate(annotationOptions: any) {
        if (!annotationOptions?.typeOptions?.points?.length) {
            return;
        }

        annotationOptions.typeOptions.points[0].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[0].actualXValue,
            annotationOptions.typeOptions.points[0].actualStartTimeT,
            this.drawingToolManager);

        annotationOptions.typeOptions.points[1].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[1].actualXValue,
            annotationOptions.typeOptions.points[1].actualStartTimeT,
            this.drawingToolManager);

        annotationOptions.typeOptions.points[2].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[2].actualXValue,
            annotationOptions.typeOptions.points[2].actualStartTimeT,
            this.drawingToolManager);

        annotationOptions.typeOptions.points[3].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[3].actualXValue,
            annotationOptions.typeOptions.points[3].actualStartTimeT,
            this.drawingToolManager);

        this.annotation.update(annotationOptions);
        this.drawingToolManager.updateAnnotationStyles(this.annotation, annotationOptions, false);
    }

    public getMetaData(): any {
        if (!this.annotation.options?.typeOptions?.points?.length) {
            return null;
        }

        const firstPoint = this.annotation.options.typeOptions.points[0];
        const actualFirstPosition = DrawingToolHelpers.getActualStartTimePosition(firstPoint, this.drawingToolManager);

        const secondPoint = this.annotation.options.typeOptions.points[1];
        const actualSecondPosition = DrawingToolHelpers.getActualStartTimePosition(secondPoint, this.drawingToolManager);

        const thirdPoint = this.annotation.options.typeOptions.points[2];
        const actualThirdPosition = DrawingToolHelpers.getActualStartTimePosition(thirdPoint, this.drawingToolManager);

        const fourthPoint = this.annotation.options.typeOptions.points[3];
        const actualFourthPosition = DrawingToolHelpers.getActualStartTimePosition(fourthPoint, this.drawingToolManager);

        return {
            id: this.id,
            langKey: 'elliott3',
            type: 'elliottWave',
            typeOptions: {
                xAxis: this.annotation.options.typeOptions.xAxis,
                yAxis: this.annotation.options.typeOptions.yAxis,
                line: {
                    stroke: this.annotation.options.typeOptions.line.stroke,
                    fill: this.annotation.options.typeOptions.line.fill,
                    strokeWidth: this.annotation.options.typeOptions.line.strokeWidth
                },
                labels: this.annotation.options.typeOptions.labels,
                points: [{
                    x: firstPoint.x,
                    actualStartTimeT: actualFirstPosition?.actualStartTimeT,
                    actualXValue: actualFirstPosition?.actualXValue,

                    y: firstPoint.y,
                }, {
                    x: secondPoint.x,
                    actualStartTimeT: actualSecondPosition?.actualStartTimeT,
                    actualXValue: actualSecondPosition?.actualXValue,

                    y: secondPoint.y,
                }, {
                    x: thirdPoint.x,
                    actualStartTimeT: actualThirdPosition?.actualStartTimeT,
                    actualXValue: actualThirdPosition?.actualXValue,

                    y: thirdPoint.y,
                }, {
                    x: fourthPoint.x,
                    actualStartTimeT: actualFourthPosition?.actualStartTimeT,
                    actualXValue: actualFourthPosition?.actualXValue,

                    y: fourthPoint.y,
                }]
            }
        };
    }
}